import { all, put, call, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { getErrorMsg } from "lib/fetch";
import * as actions from "./actions";

function* updatePasswordMasterDataUser(action) {
    const {
        accessToken,
        data,
        loading
    } = action.payload;
    try {
        const res = yield call(
          axios.post,
          `${process.env.REACT_APP_GO_API_ENDPOINT}/users/update/password/${data.id}`,
         data,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        loading(res.data);
        yield put(actions.updatePasswordMasterDataUser.success(res.data));
    } catch (err) {
        console.log(err.message);
        yield put(actions.updatePasswordMasterDataUser.failure(getErrorMsg(err)));
    }
}

export default function* watchProfile() {
    yield all([
        takeEvery(actions.UPDATE_PASSWORD_MASTERDATA_USER.REQUEST, updatePasswordMasterDataUser),
    ]);
}

export {
    updatePasswordMasterDataUser
}